function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import AttachPopover from './attach-popover';
import DEFAULTS from '../defaults';
import layout from '../templates/components/attach-popover';
import { setComponentTemplate } from '@ember/component';
class AttachTooltip extends AttachPopover {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "configKey", 'tooltip');
  }
  get ariaRole() {
    return this.args.ariaRole || 'tooltip';
  }
  get _class() {
    return `${super._class} ${this._config.tooltipClass || DEFAULTS.tooltipClass}`;
  }
  _initializeAttacher() {
    super._initializeAttacher();
    if (this._currentTarget?.getAttribute('aria-describedby') != this.id) {
      const oldTarget = document.querySelector(`[aria-describedby="${this.id}"]`);
      oldTarget?.removeAttribute('aria-describedby');
      this._currentTarget?.setAttribute('aria-describedby', this.id);
    }
  }
  willDestroy() {
    super.willDestroy(...arguments);
    const target = this._currentTarget;
    if (target) {
      target.removeAttribute('aria-describedby');
    }
  }
}
export default setComponentTemplate(layout, AttachTooltip);